<template>
  <div class="col-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1">
    <div class="row blaNavigation">
      <div class="col-5 offset-1 col-lg-5 offset-lg-1">
        <img
          :src="require('@/assets/img/skillers_logo_new_white.png')"
          alt="skillersLogo"
          class="headerLogoWhite img-fluid clickable mt-2"
          @click="$router.push({ name: 'main' })"
        />
        <img
          :src="require('@/assets/img/skillers_logo_new_purple.png')"
          alt="skillersLogo"
          class="headerLogo img-fluid clickable"
          @click="$router.push({ name: 'main' })"
        />
      </div>
      <div class="col-4 offset-1 offset-0 col-lg-3 offset-lg-3">
        <div
          class="blaLoginButton clickable"
          @click="$router.push({ name: loginRouteName })"
          :style="{ color: loginButtonColor + ' !important' }"
        >
          {{loginTitle}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  methods: {},
  props: {
    loginButtonColor: String,
    loginTitle: String,
    loginRouteName: String
  },
  mounted: () => ({}),
};
</script>
